module.exports = __webpack_public_path__ + "img/datu.eb5c6760.png";